var test = '!!!!!!!!!!';
var lat_listen_1 = document.getElementById("loc_lat");
var long_listen_1 = document.getElementById("loc_long");

var lat_listen_2_deg = document.getElementById("loc_lat2_deg");
var lat_listen_2_min = document.getElementById("loc_lat2_min");
var lat_listen_2_sec = document.getElementById("loc_lat2_sec");

var long_listen_2_deg = document.getElementById("loc_long2_deg");
var long_listen_2_min = document.getElementById("loc_long2_min");
var long_listen_2_sec = document.getElementById("loc_long2_sec");

var nom_station_list = document.getElementById("content");

var val_button = document.getElementById("val_form");

var file_to_upload = document.getElementById("photo_up");
var label_for_upload = document.getElementById("photo").innerHTML;

// var email_field = document.querySelector("[type='email']");
var email_field = document.getElementById("email");


lat_listen_1.addEventListener("keyup", function () {
    sexa_coord_lat(this);
});
long_listen_1.addEventListener("keyup", function () {
    sexa_coord_long(this);
});

lat_listen_2_deg.addEventListener("keyup", function () {
    //console.log('listener ok');
    deci_coord_lat_deg(this);
});
lat_listen_2_min.addEventListener("keyup", function () {
    //console.log('listener ok');
    deci_coord_lat_min(this);
});
lat_listen_2_sec.addEventListener("keyup", function () {
    //console.log('listener ok');
    deci_coord_lat_sec(this);
});

long_listen_2_deg.addEventListener("keyup", function () {
    //console.log('listener ok');
    deci_coord_long_deg(this);
});
long_listen_2_min.addEventListener("keyup", function () {
    //console.log('listener ok');
    deci_coord_long_min(this);
});
long_listen_2_sec.addEventListener("keyup", function () {
    //console.log('listener ok');
    deci_coord_long_sec(this);
});

nom_station_list.addEventListener("click", function () {
    create_station(document.getElementById("nom"));
    if (document.getElementById("dat_obs")) {
        check_blank(document.getElementById("dat_obs"));
    } else if (document.getElementById("double_date_1") && document.getElementById("double_date_2")) {
        check_blank(document.getElementById("double_date_1"));
        check_blank(document.getElementById("double_date_2"));
    }

});

lat_listen_1.addEventListener("blur", function () {
    dot_vs_comma(this);
});

long_listen_1.addEventListener("blur", function () {
    dot_vs_comma(this);
});

// authorized_ext défini dans fichier de conf
file_to_upload.addEventListener("change", function () {
    check_upload(this, label_for_upload, authorized_ext);
});

if(email_field) {
    email_field.addEventListener("blur", function () {
        console.log(this.validity.valid);
        if (!this.validity.valid) {
            document.getElementById('email-error-message').classList.remove('email-error-hidden');
            document.getElementById('email_li').classList.add('expanded');
            this.classList.add('error');
        } else {
            document.getElementById('email-error-message').classList.add('email-error-hidden');
            document.getElementById('email_li').classList.remove('expanded');
            this.classList.remove('error');
        }
    });
}

//val_button.addEventListener("click", function(){
//    //dot_vs_comma (lat_listen_1);
//    //dot_vs_comma (long_listen_1);
//});

// Sexa 

function sexa_coord_lat(coord_) {
    var coord_point = coord_.value.indexOf(".");
    var coord_length = coord_.value.length;
    var coord_reste = coord_length - coord_point;
    //console.log('Point = ' + coord_point);
    //console.log('Longueur = ' + coord_length);
    //console.log('Reste = ' + coord_reste);
    if (coord_.value > 0) {
        document.getElementById("loc_lat2_deg").value = "N";
    } else {
        document.getElementById("loc_lat2_deg").value = "S";
    }
    if (coord_point !== -1) {
        if (coord_.value > 0) {
            document.getElementById("loc_lat2_deg").value = document.getElementById("loc_lat2_deg").value + coord_.value.substring(0, coord_point);
        } else {
            document.getElementById("loc_lat2_deg").value = document.getElementById("loc_lat2_deg").value + coord_.value.substring(1, coord_point);
        }
        //console.log('Restant = '+coord_.value.substring((coord_point),(coord_point+coord_reste)));
        coord_2 = coord_.value.substring((coord_point), (coord_point + coord_reste));
        var coord_3 = coord_2 * 60;
        coord_3 = coord_3.toString();
        //console.log(coord_3);
        var coord_point2 = coord_3.indexOf(".");
        if (coord_point2 !== -1) {
            //console.log(coord_point2);
            var coord_length2 = coord_3.length;
            var coord_reste2 = coord_length2 - coord_point2;
            document.getElementById("loc_lat2_min").value = coord_3.substring(0, coord_point2);
            //console.log('Restant2 = '+coord_3.substring((coord_point2),(coord_point2+coord_reste2)));
            coord_4 = coord_3.substring((coord_point2), (coord_point2 + coord_reste2));
            var coord_5 = coord_4 * 60;
            arrondi = coord_5 * 100;
            arrondi = Math.round(arrondi);
            coord_5 = arrondi / 100;
            coord_5 = coord_5.toString();
            //console.log(coord_5);
            document.getElementById("loc_lat2_sec").value = coord_5;
        } else {
            document.getElementById("loc_lat2_min").value = coord_3;
            document.getElementById("loc_lat2_sec").value = "00";
        }
    } else {
        if (coord_.value > 0) {
            document.getElementById("loc_lat2_deg").value = document.getElementById("loc_lat2_deg").value + coord_.value;
        } else {
            document.getElementById("loc_lat2_deg").value = document.getElementById("loc_lat2_deg").value + coord_.value.substring(1, coord_.length);
        }
        document.getElementById("loc_lat2_min").value = "00";
        document.getElementById("loc_lat2_sec").value = "00";
    }
}

function sexa_coord_long(coord_) {
    var coord_point = coord_.value.indexOf(".");
    var coord_length = coord_.value.length;
    var coord_reste = coord_length - coord_point;
    //console.log('Point = ' + coord_point);
    //console.log('Longueur = ' + coord_length);
    //console.log('Reste = ' + coord_reste);
    if (coord_.value > 0) {
        document.getElementById("loc_long2_deg").value = "E";
    } else {
        document.getElementById("loc_long2_deg").value = "W";
    }
    if (coord_point !== -1) {
        if (coord_.value > 0) {
            document.getElementById("loc_long2_deg").value = document.getElementById("loc_long2_deg").value + coord_.value.substring(0, coord_point);
        } else {
            document.getElementById("loc_long2_deg").value = document.getElementById("loc_long2_deg").value + coord_.value.substring(1, coord_point);
        }
        //console.log('Restant = '+coord_.value.substring((coord_point),(coord_point+coord_reste)));
        coord_2 = coord_.value.substring((coord_point), (coord_point + coord_reste));
        var coord_3 = coord_2 * 60;
        coord_3 = coord_3.toString();
        //console.log(coord_3);
        var coord_point2 = coord_3.indexOf(".");
        if (coord_point2 !== -1) {
            //console.log(coord_point2);
            var coord_length2 = coord_3.length;
            var coord_reste2 = coord_length2 - coord_point2;
            document.getElementById("loc_long2_min").value = coord_3.substring(0, coord_point2);
            //console.log('Restant2 = '+coord_3.substring((coord_point2),(coord_point2+coord_reste2)));
            coord_4 = coord_3.substring((coord_point2), (coord_point2 + coord_reste2));
            var coord_5 = coord_4 * 60;
            arrondi = coord_5 * 100;
            arrondi = Math.round(arrondi);
            coord_5 = arrondi / 100;
            coord_5 = coord_5.toString();
            //console.log(coord_5);

            document.getElementById("loc_long2_sec").value = coord_5;
        } else {
            document.getElementById("loc_long2_min").value = coord_3;
            document.getElementById("loc_long2_sec").value = "00";
        }
    } else {
        if (coord_.value > 0) {
            document.getElementById("loc_long2_deg").value = document.getElementById("loc_long2_deg").value + coord_.value;
        } else {
            document.getElementById("loc_long2_deg").value = document.getElementById("loc_long2_deg").value + coord_.value.substring(1, coord_.length);
        }
        document.getElementById("loc_long2_min").value = "00";
        document.getElementById("loc_long2_sec").value = "00";
    }
}


// Déci latitude

function deci_coord_lat_deg(coord_1) {
    var champ_lat = document.getElementById("loc_lat");
    coord_point0 = champ_lat.value.indexOf(".");

    if (coord_point0 === -1) {
        if (document.getElementById("loc_lat2_deg").value.substring(0, 1) === 'N') {
            //console.log("cas 1");
            champ_lat.value = coord_1.value.substring(1, coord_1.value.length);
        }
        if (document.getElementById("loc_lat2_deg").value.substring(0, 1) === 'S') {
            //console.log("cas 2");
            champ_lat.value = '-' + coord_1.value.substring(1, coord_1.value.length);
        }
        if ((document.getElementById("loc_lat2_deg").value.substring(0, 1) !== 'S') && (document.getElementById("loc_lat2_deg").value.substring(0, 1) !== 'N')) {
            //console.log( "pas de N ni de S");
            champ_lat.value = '';
            champ_lat.value = '0';
        }
    } else {
        if (document.getElementById("loc_lat2_deg").value.substring(0, 1) === 'N') {
            //console.log("cas 3");
            champ_lat.value = coord_1.value.substring(1, coord_1.value.length) + champ_lat.value.substring(coord_point0, champ_lat.value.length);
        }
        if (document.getElementById("loc_lat2_deg").value.substring(0, 1) === 'S') {
            //console.log("cas 4");
            champ_lat.value = '-' + coord_1.value.substring(1, coord_1.value.length) + champ_lat.value.substring(coord_point0, champ_lat.value.length);
        }
        if ((document.getElementById("loc_lat2_deg").value.substring(0, 1) !== 'S') && (document.getElementById("loc_lat2_deg").value.substring(0, 1) !== 'N')) {
            //console.log( "pas de N ni de S2");
            champ_lat.value = '0' + champ_lat.value.substring(coord_point0, champ_lat.value.length);
        }

    }
}

function deci_coord_lat_min(coord_1) {

    var deg_ = document.getElementById("loc_lat2_deg");
    var min_ = coord_1;
    var sec_ = document.getElementById("loc_lat2_sec");
    var champ_lat = document.getElementById("loc_lat");

    calcul_min = min_.value / 60;
    //console.log('c1 ='+ calcul_min);  

    calcul_sec = sec_.value / 3600;
    //console.log ('c2 = '+ calcul_sec);

    calcul_tot = calcul_sec + calcul_min;
    //console.log ('c3 = '+ calcul_tot);


    calcul_min = calcul_min.toString();
    calcul_sec = calcul_sec.toString();
    calcul_tot = calcul_tot.toString();


    var coord_point3 = calcul_min.indexOf(".");
    //var coord_point4 = calcul_sec.indexOf(".");
    var coord_point5 = calcul_tot.indexOf(".");

    if ((deg_.value !== 'N') && (deg_.value !== 'S') && (deg_.value !== '')) {
        if (sec_.value === '') {
            if (deg_.value.substring(0, 1) === 'N') {
                if (calcul_min !== '0') {
                    champ_lat.value = deg_.value.substring(1, deg_.value.length) + calcul_min.substring(coord_point3, calcul_min.length);
                } else {
                    champ_lat.value = deg_.value.substring(1, deg_.value.length);
                }
            }
            if (deg_.value.substring(0, 1) === 'S') {
                if (calcul_min !== '0') {
                    champ_lat.value = '-' + deg_.value.substring(1, deg_.value.length) + calcul_min.substring(coord_point3, calcul_min.length);
                } else {
                    champ_lat.value = '-' + deg_.value.substring(1, deg_.value.length);
                }
            }
        } else {
            if (deg_.value.substring(0, 1) === 'N') {
                if (calcul_sec !== '0') {
                    champ_lat.value = deg_.value.substring(1, deg_.value.length) + calcul_tot.substring(coord_point5, calcul_tot.length);
                } else {
                    champ_lat.value = deg_.value.substring(1, deg_.value.length);
                }
            }
            if (deg_.value.substring(0, 1) === 'S') {
                if (calcul_sec !== '0') {
                    champ_lat.value = '-' + deg_.value.substring(1, deg_.value.length) + calcul_tot.substring(coord_point5, calcul_tot.length);
                } else {
                    champ_lat.value = '-' + deg_.value.substring(1, deg_.value.length);
                }
            }
        }

    } else {
        if (sec_.value === '') {
            if (calcul_min !== '0') {
                champ_lat.value = '0' + calcul_min.substring(coord_point3, calcul_min.length);
            } else {
                champ_lat.value = '0';
            }
        } else {
            //console.log ( "cas 4");
            if (calcul_sec !== '0') {
                champ_lat.value = '0' + calcul_tot.substring(coord_point5, calcul_tot.length);
            } else {
                champ_lat.value = '0';
            }
        }
    }
}

function deci_coord_lat_sec(coord_1) {

    var deg_ = document.getElementById("loc_lat2_deg");
    var min_ = document.getElementById("loc_lat2_min");
    var sec_ = coord_1;
    var champ_lat = document.getElementById("loc_lat");

    calcul_min = min_.value / 60;
    //console.log('c1 ='+ calcul_min);  

    calcul_sec = sec_.value / 3600;
    //console.log ('c2 = '+ calcul_sec);

    calcul_tot = calcul_sec + calcul_min;
    //console.log ('c3 = '+ calcul_tot);


    calcul_min = calcul_min.toString();
    calcul_sec = calcul_sec.toString();
    calcul_tot = calcul_tot.toString();


    //var coord_point3 = calcul_min.indexOf(".");
    var coord_point4 = calcul_sec.indexOf(".");
    var coord_point5 = calcul_tot.indexOf(".");

    if ((deg_.value !== 'N') && (deg_.value !== 'S') && (deg_.value !== '')) {
        if (min_.value === '') {
            if (deg_.value.substring(0, 1) === 'N') {
                if (calcul_sec !== '0') {
                    champ_lat.value = deg_.value.substring(1, deg_.value.length) + calcul_sec.substring(coord_point4, calcul_sec.length);
                } else {
                    champ_lat.value = deg_.value.substring(1, deg_.value.length);
                }
            }
            if (deg_.value.substring(0, 1) === 'S') {
                if (calcul_sec !== '0') {
                    champ_lat.value = '-' + deg_.value.substring(1, deg_.value.length) + calcul_sec.substring(coord_point4, calcul_sec.length);
                } else {
                    champ_lat.value = '-' + deg_.value.substring(1, deg_.value.length);
                }
            }
        } else {
            if (deg_.value.substring(0, 1) === 'N') {
                //console.log ( "cas 2");
                if (calcul_tot !== '0') {
                    champ_lat.value = deg_.value.substring(1, deg_.value.length) + calcul_tot.substring(coord_point5, calcul_tot.length);
                } else {
                    champ_lat.value = deg_.value.substring(1, deg_.value.length);
                }
            }
            if (deg_.value.substring(0, 1) === 'S') {
                if (calcul_tot !== '0') {
                    champ_lat.value = '-' + deg_.value.substring(1, deg_.value.length) + calcul_tot.substring(coord_point5, calcul_tot.length);
                } else {
                    champ_lat.value = '-' + deg_.value.substring(1, deg_.value.length);
                }
            }
        }

    } else {
        if (min_.value === '') {
            if (calcul_sec !== '0') {
                champ_lat.value = '0' + calcul_sec.substring(coord_point4, calcul_sec.length);
            } else {
                champ_lat.value = '0';
            }
        } else {
            //console.log ( "cas 4");
            if (calcul_tot !== '0') {
                champ_lat.value = '0' + calcul_tot.substring(coord_point5, calcul_tot.length);
            } else {
                champ_lat.value = '0';
            }
        }
    }
}


// Déci longitude

function deci_coord_long_deg(coord_2) {
    var champ_long = document.getElementById("loc_long");
    coord_point00 = champ_long.value.indexOf(".");
    //console.log (coord_point00);

    if (coord_point00 === -1) {
        if (document.getElementById("loc_long2_deg").value.substring(0, 1) === 'E') {
            //console.log("cas 1");
            champ_long.value = coord_2.value.substring(1, coord_2.value.length);
        }
        if (document.getElementById("loc_long2_deg").value.substring(0, 1) === 'W') {
            //console.log("cas 2");
            champ_long.value = '-' + coord_2.value.substring(1, coord_2.value.length);
        }
        if ((document.getElementById("loc_long2_deg").value.substring(0, 1) !== 'W') && (document.getElementById("loc_long2_deg").value.substring(0, 1) !== 'E')) {
            //console.log( "pas de E ni de W");
            champ_long.value = '0';
        }
    } else {
        if (document.getElementById("loc_long2_deg").value.substring(0, 1) === 'E') {
            //console.log("cas 3");
            champ_long.value = coord_2.value.substring(1, coord_2.value.length) + champ_long.value.substring(coord_point00, champ_long.value.length);
        }
        if (document.getElementById("loc_long2_deg").value.substring(0, 1) === 'W') {
            //console.log("cas 4");
            champ_long.value = '-' + coord_2.value.substring(1, coord_2.value.length) + champ_long.value.substring(coord_point00, champ_long.value.length);
        }
        if ((document.getElementById("loc_long2_deg").value.substring(0, 1) !== 'W') && (document.getElementById("loc_long2_deg").value.substring(0, 1) !== 'E')) {
            //console.log( "pas de E ni de W2");
            champ_long.value = '0' + champ_long.value.substring(coord_point00, champ_long.value.length);
        }

    }
}

function deci_coord_long_min(coord_2) {

    var deg_ = document.getElementById("loc_long2_deg");
    var min_ = coord_2;
    var sec_ = document.getElementById("loc_long2_sec");
    var champ_long = document.getElementById("loc_long");

    calcul_min = min_.value / 60;
    //console.log('c1 ='+ calcul_min);  

    calcul_sec = sec_.value / 3600;
    //console.log ('c2 = '+ calcul_sec);

    calcul_tot = calcul_sec + calcul_min;
    //console.log ('c3 = '+ calcul_tot);


    calcul_min = calcul_min.toString();
    calcul_sec = calcul_sec.toString();
    calcul_tot = calcul_tot.toString();


    var coord_point3 = calcul_min.indexOf(".");
    //var coord_point4 = calcul_sec.indexOf(".");
    var coord_point5 = calcul_tot.indexOf(".");

    if ((deg_.value !== 'E') && (deg_.value !== 'W') && (deg_.value !== '')) {
        if (sec_.value === '') {
            if (deg_.value.substring(0, 1) === 'E') {
                if (calcul_min !== '0') {
                    champ_long.value = deg_.value.substring(1, deg_.value.length) + calcul_min.substring(coord_point3, calcul_min.length);
                } else {
                    champ_long.value = deg_.value.substring(1, deg_.value.length);
                }
            }
            if (deg_.value.substring(0, 1) === 'W') {
                if (calcul_min !== '0') {
                    champ_long.value = '-' + deg_.value.substring(1, deg_.value.length) + calcul_min.substring(coord_point3, calcul_min.length);
                } else {
                    champ_long.value = '-' + deg_.value.substring(1, deg_.value.length);
                }
            }
        } else {
            if (deg_.value.substring(0, 1) === 'E') {
                if (calcul_sec !== '0') {
                    champ_long.value = deg_.value.substring(1, deg_.value.length) + calcul_tot.substring(coord_point5, calcul_tot.length);
                } else {
                    champ_long.value = deg_.value.substring(1, deg_.value.length);
                }
            }
            if (deg_.value.substring(0, 1) === 'W') {
                if (calcul_sec !== '0') {
                    champ_long.value = '-' + deg_.value.substring(1, deg_.value.length) + calcul_tot.substring(coord_point5, calcul_tot.length);
                } else {
                    champ_long.value = '-' + deg_.value.substring(1, deg_.value.length);
                }
            }
        }

    } else {
        if (sec_.value === '') {
            if (calcul_min !== '0') {
                champ_long.value = '0' + calcul_min.substring(coord_point3, calcul_min.length);
            } else {
                champ_long.value = '0';
            }
        } else {
            //console.log ( "cas 4");
            if (calcul_sec !== '0') {
                champ_long.value = '0' + calcul_tot.substring(coord_point5, calcul_tot.length);
            } else {
                champ_long.value = '0';
            }
        }
    }
}

function deci_coord_long_sec(coord_2) {

    var deg_ = document.getElementById("loc_long2_deg");
    var min_ = document.getElementById("loc_long2_min");
    var sec_ = coord_2;
    var champ_long = document.getElementById("loc_long");

    calcul_min = min_.value / 60;
    //console.log('c1 ='+ calcul_min);  

    calcul_sec = sec_.value / 3600;
    //console.log ('c2 = '+ calcul_sec);

    calcul_tot = calcul_sec + calcul_min;
    //console.log ('c3 = '+ calcul_tot);


    calcul_min = calcul_min.toString();
    calcul_sec = calcul_sec.toString();
    calcul_tot = calcul_tot.toString();


    //var coord_point3 = calcul_min.indexOf(".");
    var coord_point4 = calcul_sec.indexOf(".");
    var coord_point5 = calcul_tot.indexOf(".");

    if ((deg_.value !== 'E') && (deg_.value !== 'W') && (deg_.value !== '')) {
        if (min_.value === '') {
            if (deg_.value.substring(0, 1) === 'E') {
                if (calcul_sec !== '0') {
                    champ_long.value = deg_.value.substring(1, deg_.value.length) + calcul_sec.substring(coord_point4, calcul_sec.length);
                } else {
                    champ_long.value = deg_.value.substring(1, deg_.value.length);
                }
            }
            if (deg_.value.substring(0, 1) === 'W') {
                if (calcul_sec !== '0') {
                    champ_long.value = '-' + deg_.value.substring(1, deg_.value.length) + calcul_sec.substring(coord_point4, calcul_sec.length);
                } else {
                    champ_long.value = '-' + deg_.value.substring(1, deg_.value.length);
                }
            }
        } else {
            if (deg_.value.substring(0, 1) === 'E') {
                //console.log ( "cas 2");
                if (calcul_tot !== '0') {
                    champ_long.value = deg_.value.substring(1, deg_.value.length) + calcul_tot.substring(coord_point5, calcul_tot.length);
                } else {
                    champ_long.value = deg_.value.substring(1, deg_.value.length);
                }
            }
            if (deg_.value.substring(0, 1) === 'W') {
                if (calcul_tot !== '0') {
                    champ_long.value = '-' + deg_.value.substring(1, deg_.value.length) + calcul_tot.substring(coord_point5, calcul_tot.length);
                } else {
                    champ_long.value = '-' + deg_.value.substring(1, deg_.value.length);
                }
            }
        }

    } else {
        if (min_.value === '') {
            if (calcul_sec !== '0') {
                champ_long.value = '0' + calcul_sec.substring(coord_point4, calcul_sec.length);
            } else {
                champ_long.value = '0';
            }
        } else {
            //console.log ( "cas 4");
            if (calcul_tot !== '0') {
                champ_long.value = '0' + calcul_tot.substring(coord_point5, calcul_tot.length);
            } else {
                champ_long.value = '0';
            }
        }
    }
}


function liste_show(duo_array, duo_array_nb, conf_quest) {

    var i;
    var k;
    var m;

    // i : valeur de la clé de l'array duo_array. Des id de checkbox et de radios.
    for (i in duo_array) {
        var li_field = i + '_li';
        //console.log(li_field);
        //console.log(document.getElementById(li_field));
        document.getElementById(li_field).style.height = '0px';
        document.getElementById(li_field).classList.remove('expanded');
        for (j = 0; j < duo_array_nb[i]; j++) {
            //console.log(duo_array[i]+'_'+j+'_field_label');
            document.getElementById(duo_array[i] + '_' + j + '_field_label').innerHTML += ' <strong><font color=red>*</font></strong>';
            var champs = document.getElementById(i);

            //console.log(duo_array[champs.id]+'_'+j);
            // Test au chargement de la page après un échec d'envoi du formulaire : garder ouvertes les div des champs non renseignés
            //console.log(document.getElementById(duo_array[champs.id]+'_'+j+'_field').value);
            if (document.getElementById(duo_array[champs.id] + '_' + j + '_field').value === '') {
                //console.log (duo_array[champs.id]+'_'+m);
                document.getElementById(duo_array[champs.id] + '_' + j).style.display = 'none';

            } else {
                document.getElementById(duo_array[champs.id] + '_' + j).style.display = 'block';
                document.getElementById(li_field).style.height = '38px';
                document.getElementById(li_field).classList.add('expanded');
            }
//        if (champs.value !== 'Autres') {
//            document.getElementById(duo_array[champs.id]).style.display = 'block';
//        }

            /* jshint ignore:start */
            champs.addEventListener("change", function () {

                var nom_champ_liste = duo_array[this.id];
                var li_field2 = this.id + '_li';

                for (k in conf_quest) {
                    if (this.id === conf_quest[k][3]) {
                        test = conf_quest[k][0];
                        //console.log(k);

                        if (this.value === test) {

                            if (conf_quest[k][2] === null) {
                                console.log(nom_champ_liste + '_' + conf_quest[k][1]);
                                document.getElementById(nom_champ_liste + '_' + conf_quest[k][1]).style.display = 'block';
                                document.getElementById(nom_champ_liste + '_' + conf_quest[k][1] + '_field').required = true;
                            } else {
                                document.getElementById(nom_champ_liste + '_' + conf_quest[k][1]).style.display = 'block';
                                document.getElementById(nom_champ_liste + '_' + conf_quest[k][1] + '_field').required = true;
                                //console.log('11');
                                document.getElementById(nom_champ_liste + '_' + conf_quest[k][1] + '_field').disabled = false;
                                for (m in conf_quest[k][2]) {
                                    //console.log("test");
                                    document.getElementById(nom_champ_liste + '_' + conf_quest[k][2][m] + '_field').value = '';
                                    document.getElementById(nom_champ_liste + '_' + conf_quest[k][2][m]).style.display = 'none';
                                    document.getElementById(nom_champ_liste + '_' + conf_quest[k][2][m] + '_field').required = false;
                                    document.getElementById(nom_champ_liste + '_' + conf_quest[k][2][m] + '_field').disabled = true;
                                }
                            }

                            document.getElementById(li_field2).style.height = '38px';
                            document.getElementById(li_field2).classList.add('expanded');
                            break;
                        }
                        if (this.value !== test) {
                            //console.log(nom_champ_liste+'_'+conf_quest[k][1]);
                            if (conf_quest[k][2] === null) {
                                document.getElementById(nom_champ_liste + '_' + conf_quest[k][1]).style.display = 'none';
                                document.getElementById(li_field2).style.height = '0px';
                                document.getElementById(li_field2).classList.remove('expanded');
                                document.getElementById(nom_champ_liste + '_' + conf_quest[k][1] + '_field').value = '';
                                document.getElementById(nom_champ_liste + '_' + conf_quest[k][1] + '_field').required = false;
                            } else {
                                for (m in conf_quest[k][2]) {

                                    document.getElementById(nom_champ_liste + '_' + conf_quest[k][2][m]).style.display = 'none';
                                    document.getElementById(nom_champ_liste + '_' + conf_quest[k][2][m] + '_field').required = false;
                                    //document.getElementById(nom_champ_liste+'_'+conf_quest[k][2][m]+'_field').disabled = 'true';
                                }
                                document.getElementById(li_field2).style.height = '0px';
                                document.getElementById(li_field2).classList.remove('expanded');
                            }
                        }
                    }
                }
            });
            /* jshint ignore:end */
        }
    }
}

function radiomap_show(duo_array, duo_array_nb, conf_quest) {
    var i;
    var k;
    var m;
    //m=0;

    // i : valeur de la clé de l'array duo_array. Des id de checkbox et de radios.
    for (i in duo_array) {
        var champs = document.getElementById(i);
        //console.log(champs);

        //for (j in duo_array[i]){
        //console.log(duo_array[i][j]);
        for (k = 0; k < duo_array_nb[duo_array[i]]; k++) {
            //console.log(duo_array_nb[duo_array[i]]);
            var li_field = i + '_details_' + k + '_li';

            //console.log(i+'_details_'+k+'_field_label');
            document.getElementById(i + '_details_' + k + '_field_label').innerHTML += ' <strong><font color=red>*</font></strong>';

            //console.log(document.getElementById(i));
            if (document.getElementById(i).checked === false) {
                document.getElementById(i + '_details_' + k).style.display = 'none';
                document.getElementById(li_field).style.height = '0px';
                document.getElementById(li_field).classList.remove('expanded');
            }
            //console.log(i+'_details_'+k);
        }
        //for (l in duo_array_nb){


        var field_ = i + '_details_' + k;


        // Test au chargement de la page après un échec d'envoi du formulaire : garder ouvertes les div des champs non renseignés

        /* jshint ignore:start */
        champs.addEventListener("change", function () {

            //var nom_champ_liste = duo_array[this.id];
            //var li_field2 = this.id +'_details_'+0+'_li';
            //console.log(this.value);
            //console.log(nom_champ_liste);
            //q=0;
            //console.log(this.id);
            for (var r in duo_array) {
                //console.log(duo_array[k]);
                if (this.value === duo_array[r]) {
                    for (q = 0; q < duo_array_nb[duo_array[r]]; q++) {
                        //console.log(this.id+'_details_'+q);

                        //console.log(duo_array[r]);
                        //console.log(q);
                        document.getElementById(this.id + '_details_' + q).style.display = 'block';
                        document.getElementById(this.id + '_details_' + q + '_field').required = true;
                        document.getElementById(this.id + '_details_' + q + '_li').style.height = '38px';
                        document.getElementById(li_field).classList.add('expanded');
                        //break;
                    }
                } else {
                    for (q = 0; q < duo_array_nb[duo_array[r]]; q++) {
                        //console.log(r+'_details_'+q);
                        document.getElementById(r + '_details_' + q).style.display = 'none';
                        document.getElementById(r + '_details_' + q + '_field').required = false;
                        document.getElementById(r + '_details_' + q + '_field').value = '';
                        document.getElementById(r + '_details_' + q + '_li').style.height = '0px';
                        document.getElementById(li_field).classList.remove('expanded');
                    }
                }
            }
            //q++;
        });
        /* jshint ignore:end */
        //}
        //}
    }
}

function convert_accented_characters(str) {
    var conversions = {};
    /* jshint ignore:start */
    conversions['ae'] = 'ä|æ|ǽ';
    conversions['oe'] = 'ö|œ';
    conversions['ue'] = 'ü';
    conversions['Ae'] = 'Ä';
    conversions['Ue'] = 'Ü';
    conversions['Oe'] = 'Ö';
    conversions['A'] = 'À|Á|Â|Ã|Ä|Å|Ǻ|Ā|Ă|Ą|Ǎ';
    conversions['a'] = 'à|á|â|ã|å|ǻ|ā|ă|ą|ǎ|ª';
    conversions['C'] = 'Ç|Ć|Ĉ|Ċ|Č';
    conversions['c'] = 'ç|ć|ĉ|ċ|č';
    conversions['D'] = 'Ð|Ď|Đ';
    conversions['d'] = 'ð|ď|đ';
    conversions['E'] = 'È|É|Ê|Ë|Ē|Ĕ|Ė|Ę|Ě';
    conversions['e'] = 'è|é|ê|ë|ē|ĕ|ė|ę|ě';
    conversions['G'] = 'Ĝ|Ğ|Ġ|Ģ';
    conversions['g'] = 'ĝ|ğ|ġ|ģ';
    conversions['H'] = 'Ĥ|Ħ';
    conversions['h'] = 'ĥ|ħ';
    conversions['I'] = 'Ì|Í|Î|Ï|Ĩ|Ī|Ĭ|Ǐ|Į|İ';
    conversions['i'] = 'ì|í|î|ï|ĩ|ī|ĭ|ǐ|į|ı';
    conversions['J'] = 'Ĵ';
    conversions['j'] = 'ĵ';
    conversions['K'] = 'Ķ';
    conversions['k'] = 'ķ';
    conversions['L'] = 'Ĺ|Ļ|Ľ|Ŀ|Ł';
    conversions['l'] = 'ĺ|ļ|ľ|ŀ|ł';
    conversions['N'] = 'Ñ|Ń|Ņ|Ň';
    conversions['n'] = 'ñ|ń|ņ|ň|ŉ';
    conversions['O'] = 'Ò|Ó|Ô|Õ|Ō|Ŏ|Ǒ|Ő|Ơ|Ø|Ǿ';
    conversions['o'] = 'ò|ó|ô|õ|ō|ŏ|ǒ|ő|ơ|ø|ǿ|º';
    conversions['R'] = 'Ŕ|Ŗ|Ř';
    conversions['r'] = 'ŕ|ŗ|ř';
    conversions['S'] = 'Ś|Ŝ|Ş|Š';
    conversions['s'] = 'ś|ŝ|ş|š|ſ';
    conversions['T'] = 'Ţ|Ť|Ŧ';
    conversions['t'] = 'ţ|ť|ŧ';
    conversions['U'] = 'Ù|Ú|Û|Ũ|Ū|Ŭ|Ů|Ű|Ų|Ư|Ǔ|Ǖ|Ǘ|Ǚ|Ǜ';
    conversions['u'] = 'ù|ú|û|ũ|ū|ŭ|ů|ű|ų|ư|ǔ|ǖ|ǘ|ǚ|ǜ';
    conversions['Y'] = 'Ý|Ÿ|Ŷ';
    conversions['y'] = 'ý|ÿ|ŷ';
    conversions['W'] = 'Ŵ';
    conversions['w'] = 'ŵ';
    conversions['Z'] = 'Ź|Ż|Ž';
    conversions['z'] = 'ź|ż|ž';
    conversions['AE'] = 'Æ|Ǽ';
    conversions['ss'] = 'ß';
    conversions['IJ'] = 'Ĳ';
    conversions['ij'] = 'ĳ';
    conversions['OE'] = 'Œ';
    conversions['f'] = 'ƒ';
    /* jshint ignore:end */
    for (var i in conversions) {
        var re = new RegExp(conversions[i], "g");
        str = str.replace(re, i);
    }

    return str;
}

function reenc_Html(text) {
    var map = {
        '&': '',
        '<': '',
        '>': '',
        '"': '',
        "'": '',
        '/': '',
        ';': '',
        '.': '',
        ',': ''
    };

    return text.replace(/[&<>"'/;.,]/g, function (m) {
        return map[m];
    });
}

function create_station(prefixe) {

    var d = new Date();
    var d_format = d.format('ddmmyyyyhhMMss');

    //Suppression des caractères spéciaux
    prefixe = convert_accented_characters(prefixe.value);
    //prefixe = prefixe.replace(/["']/g, "");
    prefixe = prefixe.replace(/\\/g, '');
    prefixe = reenc_Html(prefixe);
    //console.log(prefixe);

    document.getElementById('nom_station').value = prefixe + d_format;
}

/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */

var dateFormat = function () {
    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
        timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
        timezoneClip = /[^-+\dA-Z]/g,
        pad = function (val, len) {
            val = String(val);
            len = len || 2;
            while (val.length < len) val = "0" + val;
            return val;
        };

    // Regexes and supporting functions are cached through closure
    return function (date, mask, utc) {
        var dF = dateFormat;

        // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
        if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
            mask = date;
            date = undefined;
        }

        // Passing date through Date applies Date.parse, if necessary
        date = date ? new Date(date) : new Date();
        if (isNaN(date)) throw SyntaxError("invalid date");

        mask = String(dF.masks[mask] || mask || dF.masks["default"]);

        // Allow setting the utc argument via the mask
        if (mask.slice(0, 4) == "UTC:") {
            mask = mask.slice(4);
            utc = true;
        }

        var _ = utc ? "getUTC" : "get",
            d = date[_ + "Date"](),
            D = date[_ + "Day"](),
            m = date[_ + "Month"](),
            y = date[_ + "FullYear"](),
            H = date[_ + "Hours"](),
            M = date[_ + "Minutes"](),
            s = date[_ + "Seconds"](),
            L = date[_ + "Milliseconds"](),
            o = utc ? 0 : date.getTimezoneOffset(),
            flags = {
                d: d,
                dd: pad(d),
                ddd: dF.i18n.dayNames[D],
                dddd: dF.i18n.dayNames[D + 7],
                m: m + 1,
                mm: pad(m + 1),
                mmm: dF.i18n.monthNames[m],
                mmmm: dF.i18n.monthNames[m + 12],
                yy: String(y).slice(2),
                yyyy: y,
                h: H % 12 || 12,
                hh: pad(H % 12 || 12),
                H: H,
                HH: pad(H),
                M: M,
                MM: pad(M),
                s: s,
                ss: pad(s),
                l: pad(L, 3),
                L: pad(L > 99 ? Math.round(L / 10) : L),
                t: H < 12 ? "a" : "p",
                tt: H < 12 ? "am" : "pm",
                T: H < 12 ? "A" : "P",
                TT: H < 12 ? "AM" : "PM",
                Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
                o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
                S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
            };

        return mask.replace(token, function ($0) {
            return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
        });
    };
}();

// Some common format strings
dateFormat.masks = {
    "default": "ddd mmm dd yyyy HH:MM:ss",
    shortDate: "m/d/yy",
    mediumDate: "mmm d, yyyy",
    longDate: "mmmm d, yyyy",
    fullDate: "dddd, mmmm d, yyyy",
    shortTime: "h:MM TT",
    mediumTime: "h:MM:ss TT",
    longTime: "h:MM:ss TT Z",
    isoDate: "yyyy-mm-dd",
    isoTime: "HH:MM:ss",
    isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};

// Internationalization strings
dateFormat.i18n = {
    dayNames: [
        "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
        "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ],
    monthNames: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ]
};

// For convenience...
Date.prototype.format = function (mask, utc) {
    return dateFormat(this, mask, utc);
};

disabled_fields = document.getElementsByClassName('disab');
for (i = 0; i < disabled_fields.length; i++) {
    //console.log(disabled_fields[i]);
    disabled_fields[i].disabled = true;
}

function trim(stringToTrim) {
    return stringToTrim.replace(/^\s+|\s+$/g, "");
}

function check_blank(check_trigger) {

    check_trigger.addEventListener("click", function () {
        //console.log(str);
        str = document.getElementsByClassName("champs_CMS");
        for (var i in str) {
            //console.log(str[i]);
            //console.log(str[i].value);
            if ((str[i].value !== undefined) && (str[i].value !== '')) {
                str_tocheck = str[i].value;
                //console.log(str_tocheck);
                //console.log(document.getElementById(str[i].id).hasAttribute("value"));
                str_tocheck = str_tocheck.replace(/\s+/g, '');
                if ((str_tocheck.length === 0) && (str[i].id !== undefined)) {
                    //console.log(str[i].name+' = '+str_tocheck.length);
                    //str_tocheck.replace(/\s+/g, '');
                    //console.log("Gotcha !"+str[i].name);
                    document.getElementById(str[i].id).value = '';
                }
            }
        }
    });
}
check_blank(val_button);

function last_verif(event) {
    disabled_fields = document.getElementsByClassName('disab');
    for (i = 0; i < disabled_fields.length; i++) {
        //console.log(disabled_fields[i]);
        disabled_fields[i].disabled = false;
    }
}

function dot_vs_comma(loca) {
    //console.log(loca.value);
    loca.value = loca.value.replace(',', '.');
    loca.value = loca.value.replace(/[^0-9\.-]+/g, '');
}

function fill_form(field, field_value) {
    document.getElementById(field).value = field_value;
}

function check_upload(upload_file, label_for_upload, authorized_ext) {

    //var upload_file = document.getElementById("photo_up");
    var file_ext;
    var file;
    var photo = document.getElementById("photo");

    if ((upload_file.value !== undefined) && (upload_file.value !== '')) {
        file_ext = upload_file.value.substr(upload_file.value.lastIndexOf('.') + 1, 3);
        if (authorized_ext.indexOf(file_ext) !== -1) {
            photo.innerHTML = label_for_upload;
            photo.parentElement.style.color = '';
            photo.parentElement.style.backgroundColor = '';
        } else {
            photo.innerHTML = "Non conforme.";
            photo.parentElement.style.color = "white";
            photo.parentElement.style.backgroundColor = "red";
            upload_file.value = '';
        }
        if (!upload_file.files) {
            // pas supporté
        } else if (!upload_file.files[0]) {
            // pas d'image
        } else {
            file = upload_file.files[0];
            if (file.size > 10000000) {
                photo.innerHTML = "Trop volumineux.";
                photo.parentElement.style.color = "white";
                photo.parentElement.style.backgroundColor = "red";
                upload_file.value = '';

            } else {
                photo.innerHTML = label_for_upload;
                photo.parentElement.style.color = '';
                photo.parentElement.style.backgroundColor = '';
            }
            //console.log('taille : '+Math.round(file.size/1024/1024*100)/100+'Mo');
        }
    }
}

trigger_second_val = document.getElementById('val_form_2');
if (trigger_second_val) {
    trigger_second_val.addEventListener('click', function () {
        document.getElementById('val_form').click();
        return false;
    });
}

function check_input_vm() {
    // console.log("********** change!");
    var globalCheck = true;
    var coordsCheck = true;
    var form = document.getElementById("form");
    var all_input = form.getElementsByTagName("input");
    var coordsError = document.getElementById('coords_error');
    var latRegexp = /^(\+|-)?((\d((\.)|\.\d{1,20})?)|(0*?[0-8]\d((\.)|\.\d{1,20})?)|(0*?90((\.)|\.0{1,20})?))$/g;
    var longRegexp = /^(\+|-)?((\d((\.)|\.\d{1,20})?)|(0*?\d\d((\.)|\.\d{1,20})?)|(0*?1[0-7]\d((\.)|\.\d{1,20})?)|(0*?180((\.)|\.0{1,20})?))$/g;

    for (var i in all_input) {
        if (all_input[i].required === true) {
            console.log(all_input[i].id + " " + all_input[i].validity.valid);
            if (all_input[i].validity.valid === true) {
                globalCheck = !!globalCheck;
            } else {
                globalCheck = false;
                // break;
            }
        }
        if (all_input[i].id === 'loc_lat') {
            if (latRegexp.test(all_input[i].value)) {
                globalCheck = !!globalCheck;
                if(coordsCheck) {
                    coordsError.style.display = 'none';
                }
            } else {
                globalCheck = false;
                coordsCheck = false;
                coordsError.style.display = 'block';
                // break;
            }
        } else if (all_input[i].id === 'loc_long') {
            if (longRegexp.test(all_input[i].value)) {
                globalCheck = !!globalCheck;
                if(coordsCheck) {
                    coordsError.style.display = 'none';
                }
            } else {
                globalCheck = false;
                coordsCheck = false;
                coordsError.style.display = 'block';
                // break;
            }
        }
    }
    enabledVal(globalCheck);
}

function enabledVal(globalCheck) {
    if (globalCheck) {
        document.getElementById("val_form").disabled = false;
    } else {
        document.getElementById("val_form").disabled = true;
    }
}

// (function listener(){
var formulaire = document.getElementById("form");
enabledVal(false);
formulaire.addEventListener("change", function () {
    check_input_vm();
});
lat_listen_1.addEventListener("change", function () {
    check_input_vm();
});
long_listen_1.addEventListener("change", function () {
    check_input_vm();
});
var checkO = (document.getElementsByTagName("input"));
for (var i = 0; i < checkO.length; i++) {
    if (checkO[i].type === 'checkbox') {
        console.log(checkO[i]);
        checkO[i].checked = false;
    }
}